module.exports = __webpack_public_path__ + "static/clients-d9b4095c11a84b260002bcf5ea50ba20.jpg";